var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.showEdit)?[_c('Head'),_c('Content')]:_c('Middleware',{on:{"complete":_vm.handleComplete}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }